<div class="d-none d-lg-block d-xl-none d-none d-xl-block">

       <img src="../../../assets/genel/solbgYeni.png" class="solDeger" width="auto" alt="">

</div>

<div class="container">

       <div class="row">
              <app-slider [language]="rootModel.language" [sliderClass]="''"></app-slider>
       </div>

       <div class="row" style="margin-top: 40px;">
              <div class="col-lg-5"></div>
              <div class="col-lg-1 ">

                     <a class="d-none d-lg-block d-xl-none d-none d-xl-block" href="#slider" role="button" data-slide="prev">
                            <img src="../../../assets/genel/sliderSol.png" alt="" width="60" height="auto">
                            <span class="sr-only">Previous</span>
                     </a>

              </div>
              <div class="col-lg-3 ">

              </div>
              <div class="col-lg-1 ">
                     <a class="d-none d-lg-block d-xl-none d-none d-xl-block" href="#slider" role="button" data-slide="next">
                            <img src="../../../assets/genel/sliderSag.png" alt="" width="60" height="auto">

                            <span class="sr-only">Next</span>

                     </a>
              </div>

       </div>




       <div class="row"  style="margin-top: 40px;">
              <div class="col-lg-6" >
                     <div class="divider"></div>


              </div>

              <!-- <div class="col-lg-4">
                     <div class="divider"></div>

                   <a  routerLink="/detay/archive"> <img src="../../../assets/genel/cover.jpg"></a>
                     <br>
              </div> -->

              <div class="col-lg-4" *ngIf="page.page_type_code===epageTypeEnum.content">
                     <div class="divider"></div>
                     <div innerHTML="{{page.content}}"></div>
                     <br>
              </div>
             <!-- son sayı denilince buraya ayrı bir tasarım yapılım sanSayıComponenti gelmezi lazım -->
              <div class="col-lg-12" *ngIf="page.page_type_code===epageTypeEnum.son_sayi">
                     <div class="divider"></div>
                     <div innerHTML="{{page.content}}"></div>
                     <br>
              </div>
              <div class="col-lg-12" *ngIf="page.page_type_code===epageTypeEnum.arsiv">
                     <app-archive></app-archive>
              </div>
       </div>


</div>